'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-icofont/~/react/react.js
// module id = 504
// module chunks = 0